import { GET } from "./";
export const termCondition = {
  get: () => GET(`/api/termCondition/`)
};
